export default {
  name: "count-down",
  components: {},
  props: ["time"],
  data() {
    return {
      countDown: 0
    };
  },
  computed: {
    minute() {
      return parseInt(this.countDown / 60000);
    },

    second() {
      return parseInt((this.countDown % 60000) / 1000);
    }
  },

  created() {
    this.countDown = this.time;
  },

  mounted() {
    this.countDownTimer();
  },

  methods: {
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1000;
          this.countDownTimer();
        }, 1000);
      } else {
        this.$emit("finish");
      }
    }
  }
};
